import React from 'react';
import { FaChartLine, FaShieldAlt, FaLeaf, FaBriefcase, FaBalanceScale } from 'react-icons/fa';
import {
  ProfileCard,
  CardTitle,
  CardContent,
  ProposalList,
  ProposalItem,
  ProposalIcon,
  ProposalText
} from './styles';

const ProposalsSection = () => {
  return (
    <ProfileCard>
      <CardTitle>Propuestas Destacadas</CardTitle>
      <CardContent>
        <ProposalList>
          <ProposalItem>
            <ProposalIcon><FaChartLine /></ProposalIcon>
            <ProposalText>Planificación urbana con visión a 20 años, no improvisada</ProposalText>
          </ProposalItem>
          <ProposalItem>
            <ProposalIcon><FaShieldAlt /></ProposalIcon>
            <ProposalText>Seguridad integral con participación ciudadana y tecnología</ProposalText>
          </ProposalItem>
          <ProposalItem>
            <ProposalIcon><FaLeaf /></ProposalIcon>
            <ProposalText>Protección de humedales y desarrollo sostenible</ProposalText>
          </ProposalItem>
          <ProposalItem>
            <ProposalIcon><FaBriefcase /></ProposalIcon>
            <ProposalText>Promoción de emprendimientos y reducción de burocracia</ProposalText>
          </ProposalItem>
          <ProposalItem>
            <ProposalIcon><FaBalanceScale /></ProposalIcon>
            <ProposalText>Transparencia en la gestión pública y rendición de cuentas</ProposalText>
          </ProposalItem>
        </ProposalList>
      </CardContent>
    </ProfileCard>
  );
};

export default ProposalsSection;
